import React, { createContext, useState } from 'react'

// types.ts
export interface BreadcrumbsItem {
  sectionName?: string
  questionName?: string
  profileName?: string
  organizationName?: string
  serviceLocations?: string
  serviceLocationName?: string
  clinicians?: string
  cliniciansName?: string
}

export interface BreadcrumbsContextType {
  breadcrumbs: BreadcrumbsItem
  setBreadcrumbs: (
    breadcrumbs: BreadcrumbsItem | ((prev: BreadcrumbsItem) => BreadcrumbsItem)
  ) => void
}

const defaultValues: BreadcrumbsContextType = {
  breadcrumbs: {},
  setBreadcrumbs: () => {},
}

export const BreadcrumbsContext =
  createContext<BreadcrumbsContextType>(defaultValues)

const BreadcrumbProvider = ({ children }: { children: React.ReactNode }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsItem>({})

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  )
}

export default BreadcrumbProvider
